// src/services/twinSimulationApi.js
// FlowSense MOW+ — Digital Twin extras on the simulation API (backend: routes/simulationRoutes.js)
import { authenticatedFetch } from './api';

const unwrap = (body, what) => {
  if (!body || body.success === false) {
    const err = new Error(body?.error || body?.message || `${what} failed`);
    err.code = body?.code || null;
    throw err;
  }
  return body;
};

/** Live run-off forecast for wells / catch basins (cached server-side ~15 min). */
export const getDrainageOutlook = async ({ force = false, signal } = {}) =>
  unwrap(await authenticatedFetch(`/simulations/drainage-outlook${force ? '?force=1' : ''}`, signal ? { signal } : {}), 'Drainage outlook');

/** Recent simulation runs kept by the server (summaries only). */
export const listSimulationRuns = async ({ scenario, signal } = {}) =>
  unwrap(await authenticatedFetch(`/simulations/runs${scenario ? `?scenario=${encodeURIComponent(scenario)}` : ''}`, signal ? { signal } : {}), 'Simulation runs').data || [];

/** Engine / topology status — includes how much of the twin stands on TessaDEM terrain. */
export const getSimulationStatus = async ({ signal } = {}) =>
  unwrap(await authenticatedFetch('/simulations/status', signal ? { signal } : {}), 'Simulation status').data;
